import { useQuery } from '@apollo/client/react';
import { MemberDocument } from '../graphql/types';
import { getMemberName } from '../utils/getMemberName';

/**
 * Resolves the display name of a member by id.
 *
 * Reuses the same `member` query the profile page runs, so when navigating
 * from a member's profile the name is served straight from the Apollo cache
 * with no extra request; a cold deep-link fetches it. Returns `undefined`
 * when no `memberId` is given or until the member is available.
 */
export const useMemberName = (
  memberId?: string,
  options?: { lastNameInitial?: boolean },
) => {
  const { data } = useQuery(MemberDocument, {
    variables: { id: memberId! },
    skip: !memberId,
  });

  return data?.user ? getMemberName(data.user, options) : undefined;
};
